import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { endBenefitProgramPolicy } from 'Services/JOONAdmin/benefitProgramCategoriesService'

export const useEndBenefitProgramPolicyQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.EndBenefitProgramPolicy], endBenefitProgramPolicy, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerBenefitPrograms])
        toast.success(AppNotification.UpdateBenefitProgramPolicySuccess)
      } else {
        toast.error(`${AppNotification.UpdateBenefitProgramPolicyFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.UpdateBenefitProgramPolicyFailure)
    }
  })
}
